import get from '@/ajax/favorites/get';
import add from '@/ajax/favorites/add';
import remove from '@/ajax/favorites/remove';
import clear from '@/ajax/favorites/clear';

/**
 * @module ajaxAPI/favorites
 *
 * @description
 * Ajax-обертки для работы с избранным
 */

const favorites = {
  get,
  add,
  remove,
  clear
};

export default favorites;
